export default {
  none: 'NONE',
  requested: 'REQUESTED',
  assigned: 'ASSIGNED',
  inProgress: 'INPROGRESS'
};
